import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { VideoUtilitiesService } from 'src/app/shared/services/videoUtilities/video-utilities.service';
import { QuestionItem } from 'src/app/shared/models/questionItem';
import { NavigatorService } from 'src/app/shared/services/navigator/navigator.service';

@Component({
  selector: 'app-question-info-text',
  templateUrl: './questionInfoText.component.html',
  styleUrls: ['./questionInfoText.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionInfoTextComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() transformedText!: any[];
  @Input() question!: QuestionItem;
  private isApp: boolean = inject(NavigatorService).isApp;

  constructor(
    private videoUtilitiesService: VideoUtilitiesService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.transformedText = this.videoUtilitiesService.getVideosFromText(
      this.question?.text,
    );
  }

  ngAfterViewInit(): void {
    const links: HTMLAnchorElement[] = this.getLinks();

    links.forEach(link => {
      link.addEventListener('click', this.onLinkClick.bind(this));
    });
  }

  onLinkClick(event: Event): void {
    event.preventDefault();
    const link = (event.target as HTMLAnchorElement).href;
    window.open(this.isApp ? `external-${link}` : link, '_blank');
  }

  private getLinks(): HTMLAnchorElement[] {
    return this.elementRef.nativeElement.querySelectorAll('a');
  }

  ngOnDestroy(): void {
    const links: HTMLAnchorElement[] = this.getLinks();

    links.forEach(link => {
      link.removeEventListener('click', this.onLinkClick.bind(this));
    });
  }
}
